import { useState, useEffect } from 'react';

const STORAGE_KEY = 'dino_recent_searches';
const MAX_RECENT_SEARCHES = 5;

export interface RecentSearch {
  query: string;
  timestamp: number;
  type: 'title' | 'author' | 'isbn';
}

export function useRecentSearches() {
  const [recentSearches, setRecentSearches] = useState<RecentSearch[]>([]);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      try {
        setRecentSearches(JSON.parse(stored));
      } catch (e) {
        console.error('Failed to parse recent searches:', e);
      }
    }
  }, []);

  const addRecentSearch = (query: string, type: 'title' | 'author' | 'isbn' = 'title') => {
    setRecentSearches(prev => {
      // Remove duplicates and add new search at the beginning
      const filtered = prev.filter(s => s.query.toLowerCase() !== query.toLowerCase());
      const updated = [
        { query, timestamp: Date.now(), type },
        ...filtered
      ].slice(0, MAX_RECENT_SEARCHES);
      
      localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
      return updated;
    });
  };

  const clearRecentSearches = () => {
    setRecentSearches([]);
    localStorage.removeItem(STORAGE_KEY);
  };

  return {
    recentSearches,
    addRecentSearch,
    clearRecentSearches
  };
}